import { Avatar, Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { InlineEmployee } from 'modules/employees/components/InlineEmployee'

import { Card } from './types'

export const Cardholder = ({ card }: { card: Card }) => {
  const cardholder = card.cardholder

  if (cardholder.employee?.access) {
    return <InlineEmployee employee={cardholder.employee} variant="medium" linkProfile />
  } else {
    return (
      <Box flexDirection="row" alignItems="center" gap="s16">
        <Avatar size="s40" label={i18n.t('banking.payments.unknown_person')} />
        <Text.Normal size="200">{i18n.t('banking.payments.unknown_person')}</Text.Normal>
      </Box>
    )
  }
}
